var map = {
	"./Image 1.png": 452,
	"./arifwala-dark.png": 453,
	"./arifwala.png": 454,
	"./assign-icon.png": 455,
	"./bahawalnagar-dark.png": 456,
	"./bahawalnagar.png": 457,
	"./bhalwal-dark.png": 458,
	"./bhalwal.png": 459,
	"./burewala-dark.png": 460,
	"./burewala.png": 461,
	"./cell.png": 462,
	"./clhs-logo-light.png": 193,
	"./collection-center.png": 463,
	"./comment-img.png": 346,
	"./dera ghazi khan-dark.png": 464,
	"./dera ghazi khan.png": 465,
	"./error-icon.png": 194,
	"./graphic.png": 466,
	"./gujrat-dark.png": 467,
	"./gujrat.png": 468,
	"./icon1-d.png": 469,
	"./icon1.png": 470,
	"./icon2-d.png": 471,
	"./icon2.png": 286,
	"./icon3-d.png": 472,
	"./icon3.png": 473,
	"./icon4-d.png": 474,
	"./icon4.png": 475,
	"./icon5-d.png": 476,
	"./icon5.png": 477,
	"./icon6-d.png": 478,
	"./icon6.png": 479,
	"./icon7-d.png": 480,
	"./icon7.png": 481,
	"./img-1.png": 260,
	"./img.png": 482,
	"./kasur-dark.png": 483,
	"./kasur.png": 484,
	"./khanewal-dark.png": 485,
	"./khanewal.png": 486,
	"./kharian-dark.png": 487,
	"./kharian.png": 488,
	"./lalamusa-dark.png": 489,
	"./lalamusa.png": 490,
	"./larkana-dark.png": 491,
	"./larkana.png": 492,
	"./layyah-dark.png": 493,
	"./layyah.png": 494,
	"./loction-icon.png": 287,
	"./logo.png": 495,
	"./logo2.png": 145,
	"./man.png": 347,
	"./mandi bahauddin-dark.png": 496,
	"./mandi bahauddin.png": 497,
	"./mianwali-dark.png": 498,
	"./mianwali.png": 499,
	"./muzaffargarh-dark.png": 500,
	"./muzaffargarh.png": 501,
	"./no-patient-selected.png": 348,
	"./no-test.png": 191,
	"./okara-dark.png": 502,
	"./okara.png": 503,
	"./phalia-dark.png": 504,
	"./phalia.png": 505,
	"./quetta-dark.png": 506,
	"./quetta.png": 507,
	"./rahim yar khan-dark.png": 508,
	"./rahim yar khan.png": 509,
	"./re-assignment.png": 288,
	"./refresh-white.png": 47,
	"./refresh.png": 510,
	"./sahiwal-dark.png": 511,
	"./sahiwal.png": 512,
	"./sargodha-dark.png": 513,
	"./sargodha.png": 514,
	"./spot.png": 515,
	"./toba tek singh-dark.png": 516,
	"./toba tek singh.png": 517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;